import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/easyflow/HomeView.vue'
import AppView from '../views/app/AppView.vue'
import LoginView from '../views/LoginView.vue'
import AppRegister from '../views/AppRegister.vue'
import AppGeneratorKey from '../views/AppGeneratorKey.vue' 
import { get } from '@/utils/local'
import { isAdminMode } from '@/utils/tenant'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'login',
        component: LoginView
    },
    {
        path: '/login',
        name: 'login',
        component: LoginView
    },
    {
        path: '/app-register',
        name: 'app-register',
        component: AppRegister
    }, 
    {
        path: '/app-generator-key',
        name: 'app-generator-key',
        component: AppGeneratorKey
    },
    {
        path: '/index/:id?',
        name: 'index',
        component: AppView,
        children: [{
            path: 'app/:id',
            component: () => import('../views/app/App.vue')
        },{
            path: 'report/:id',
            component: () => import('../views/report/ReportAppView.vue')
        },{
            path: 'extapp/:id',
            component: () => import('../views/app/ExtApp.vue')
        },{
            path: 'inst-rate',
            component: () => import('../views/app/InstRate.vue')
        },        {
            path: 'patient',
            component: () => import('../views/exts/easyhis/PatientCardList.vue')
        },
        {
            path: 'patient/order',
            component: () => import('../views/exts/easyhis/PatientCardList.vue')
        },
        {
            path: 'report',
            component: () => import('../views/easyflow/report/AppReport.vue')
        },
        {
            path: 'patient/charge',
            component: () => import('../views/exts/easyhis/PatientCardList.vue')
        },{
            path: 'diag',
            component: () => import('../views/exts/easyhis/DiagList.vue')
        },{
            path: 'department',
            component: () => import('../views/exts/easyhis/DepartmentList.vue')
        },        {
            path: 'charge-dic',
            component: () => import('../views/exts/easyhis/ChargeDicList.vue')
        },{
            path: 'medicine-info',
            component: () => import('../views/exts/easyhis/MedicineInfoList.vue')
        },{
            path: 'medicine-inventory',
            component: () => import('../views/exts/easyhis/MedicineInventoryList.vue')
        },{
            path: 'medicine-batch',
            component: () => import('../views/exts/easyhis/MedicineBatchList.vue')
        },{
            path: 'medicine-batch-inventory',
            component: () => import('../views/exts/easyhis/MedicineBatchInventoryList.vue')
        },{
            path: 'medicine-stock-in',
            component: () => import('../views/exts/easyhis/MedicineStockInList.vue')
        },{
            path: 'medicine-stock-out',
            component: () => import('../views/exts/easyhis/MedicineStockOutList.vue')
        },{
            path: 'pending-stock-out-detail',
            component: () => import('../views/exts/easyhis/PendingStockOutDetailList.vue')
        },{
            path: 'medicine-stock-check',
            component: () => import('../views/exts/easyhis/MedicineStockCheckList.vue')
        },{
            path: 'medicine-stock-closing',
            component: () => import('../views/exts/easyhis/MedicineStockClosingList.vue')
        },{
            path: 'doctor',
            component: () => import('../views/exts/easyhis/DoctorList.vue')
        },{
            path: 'patient-payment',
            component: () => import('../views/exts/easyhis/PatientPaymentList.vue')
        },{
            path: 'patient-registration',
            component: () => import('../views/exts/easyhis/PatientRegistrationList.vue')
        },{
            path: 'prescription',
            component: () => import('../views/exts/easyhis/PrescriptionList.vue')
        },{
            path: 'prescription-manage',
            component: () => import('../views/exts/easyhis/PrescriptionManageList.vue')
        },{
            path: 'medical-order',
            component: () => import('../views/exts/easyhis/MedicalOrderList.vue')
        },{
            path: 'order-content-dict',
            component: () => import('../views/exts/easyhis/OrderContentDictList.vue')
        },{
            path: 'reconciliation',
            component: () => import('../views/exts/easyhis/ReconciliationList.vue')
        },{
            path: 'laboratory',
            component: () => import('../views/exts/easyhis/LaboratoryList.vue')
        },{
            path: 'settlement-summary-report',
            component: () => import('../views/exts/easyhis/SettlementSummaryReport.vue')
        }, {
            path: '/',
            component: () => import('../views/app/AppGuest.vue')
        }]
    },
    {
        path: '/home',
        name: 'home',
        component: HomeView,
        children:[{
            path: '/',
            component: () => import('../views/easyflow/HomeIndex.vue')
        }, {
            path: 'inst-rate',
            component: () => import('../views/easyflow/inst-rate/InstRateManager.vue')
        }, {
            path: 'patient',
            component: () => import('../views/easyflow/patient/PatientManager.vue')
        }, {
            path: 'reconciliation',
            component: () => import('../views/easyflow/reconciliation/ReconciliationManager.vue')
        }, {
            path: 'create',
            component: () => import('../views/easyflow/createapp/CreateApp.vue')
        }, {
            path: 'authconfig/:id?',
            component: () => import('../views/easyflow/authconfig/AuthConfig.vue')
        }, {
            path: 'authconfig-ext',
            component: () => import('../views/easyflow/authconfig/AppExtAppManager.vue')
        }, {
            path: 'datasource',
            component: () => import('../views/easyflow/datasource/DataSource.vue')
        }, {
            path: 'dic',
            component: () => import('../views/easyflow/dic/Dic.vue')
        }, {
            path: 'store',
            component: () => import('../views/easyflow/flowapp/FlowApp.vue')
        },{
            path: 'report',
            component: () => import('../views/easyflow/report/AppReport.vue')
        }, {
            path: 'form-list',
            component: () => import('../views/easyflow/forms/FormList.vue')
        }, {
            path: 'form-design',
            component: () => import('../views/index/Home.vue')
        }, {
            path: 'app/:id?',
            component: () => import('../views/easyflow/app/AppList.vue')
        }, {
            path: 'rate-app',
            component: () => import('../views/easyflow/app/RateAppList.vue')
        }, {
            path: 'org-struct',
            component: () => import('../views/easyflow/orgstruct/OrgStruct.vue')
        }, {
            path: 'hospital-info',
            component: () => import('../views/easyflow/orgstruct/HospitalManager.vue')
        }, {
            path: 'tenant-management',
            component: () => import('../views/easyflow/orgstruct/TenantManager.vue')
        }, {
            path: 'report-design',
            component: () => import('../views/easyflow/report/ReportDesign.vue')
        }, {
            path: 'setting',
            component: () => import('../views/easyflow/settings/SysSetting.vue')
        }, {
            path: 'feature-management',
            component: () => import('../views/easyflow/feature/FeatureManager.vue')
        }, {
            path: 'audit-log',
            component: () => import('../views/easyflow/orgstruct/AuditLog.vue')
        }, {
            path: 'work',
            component: () => import('../views/easyflow/workers/Workers.vue')
        }]
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/404',
        name: 'not-found',
        component: () => import('../views/NotFound.vue')
    },
    {
        path: '*',
        redirect: '/404'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

const ADMIN_ONLY_ROUTES = ['/home/hospital-info', '/home/tenant-management', '/home/feature-management']

router.beforeEach((to, from, next) => {
    // 获取用户信息
    let userInfo = get('user');
    console.log('beforeEach');
    if (ADMIN_ONLY_ROUTES.some(path => to.path.startsWith(path))) {
        if (!isAdminMode()) {
            const redirect = from && (from.fullPath || from.path) ? (from.fullPath || from.path) : '/';
            next({ path: '/404', query: { redirect } });
            return;
        }
    }
    if (!userInfo) {
        if (to.path == '/login') {
            next();
        } else if (to.path == '/app-register') {
            next();
        } else if (to.path == '/register') {
            next();
        } else {
            next('/login');
        }
        next();
    } else {
        // 有信息，正常跳转路由
        if (to.path == '/app-generator-key') {
            if (!userInfo || !userInfo.roles || !userInfo.roles.includes('sadmin')){
                next(from.path);
            } else {
                next();
            }
        } else if( to.path.startsWith('/home')) {
            if (!userInfo || !userInfo.roles || (!userInfo.roles.includes('admin') && !userInfo.roles.includes('应用管理员'))){
                next(from.path);
            } else {
                next();
            }
        } else {
            next();
        }
    }
})

export default router
